import socketService from "./socket.service";
import sessionService from "./session.service";
var FeatureToggles = /** @class */ (function () {
    function FeatureToggles() {
        var _this = this;
        this.config = {};
        this.loadToggles = function () {
            return socketService.definitlyEmit("featureToggles", {})
                .then(function (response) { return response.toggles ? _this.config = response.toggles : null; });
        };
        sessionService.bootLogin()
            .then(function () { return _this.loadToggles(); });
        sessionService.awaitLogin()
            .then(function () { return _this.loadToggles(); });
    }
    FeatureToggles.prototype.isFeatureEnabled = function (featureName) {
        if (!this.config.hasOwnProperty(featureName)) {
            // console.warn(`Unknown feature: ${featureName}`)
            return false;
        }
        if (this.config[featureName] === false) {
            return false;
        }
        return true;
    };
    FeatureToggles.prototype.getFeatureConfig = function (featureName) {
        return this.config[featureName];
    };
    return FeatureToggles;
}());
export default new FeatureToggles();



//////////////////
// WEBPACK FOOTER
// ./js/services/featureToggles.ts
// module id = qYiN
// module chunks = 1